export const GET_STREAKS_REQUEST = 'GET_STREAKS_REQUEST';
export const GET_STREAKS_SUCCESS = 'GET_STREAKS_SUCCESS';
export const GET_STREAKS_FAILURE = 'GET_STREAKS_FAILURE';
